import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LegalPage, { MarkdownLink, linkifyEmails } from "../components/LegalPage";
import { HELP, HELP_HEADING_IDS } from "../content/help";

const textOf = (c) => {
  if (typeof c === "string" || typeof c === "number") return String(c);
  if (Array.isArray(c)) return c.map(textOf).join("");
  return c?.props ? textOf(c.props.children) : "";
};

function HashLink({ href, children }) {
  const navigate = useNavigate();
  const onClick = (e) => {
    e.preventDefault();
    navigate(`/help${href}`);
  };
  return <a href={href} onClick={onClick} className="underline hover:text-neutral-900">{children}</a>;
}

const extraComponents = {
  h2: ({ children }) => (
    <h2 id={HELP_HEADING_IDS[textOf(children).trim()]}
        className="text-2xl font-semibold mt-10 mb-3 border-b border-neutral-200 pb-2 scroll-mt-6">
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3 id={HELP_HEADING_IDS[textOf(children).trim()]}
        className="text-lg font-semibold mt-6 mb-2 scroll-mt-6">
      {children}
    </h3>
  ),
  a: ({ href, children }) => (href || "").startsWith("#")
    ? <HashLink href={href}>{children}</HashLink>
    : <MarkdownLink href={href}>{children}</MarkdownLink>,
  strong: ({ children }) => (
    <strong className="font-semibold text-neutral-900">{linkifyEmails(children)}</strong>
  ),
};

export default function Help() {
  const { hash, key } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
    return () => clearTimeout(t);
  }, [hash, key]);

  return (
    <LegalPage title="Help" docTitle="Help | Lingua Franca" source={HELP}
               extraComponents={extraComponents} />
  );
}
